<template>
  <a-modal
    title="新增/编辑"
    style="top: 20px;"
    :width="800"
    v-model="visible"
    :confirmLoading="confirmLoading"
    :footer="null"
    :maskClosable="false"
  >
    <a-form :form="form" :class="status ==1 ? 'readyOnly':''">
      <a-form-item style="display:none">
        <a-input v-decorator="['id']"/>
      </a-form-item>
      <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="安装类别">
        <a-select v-decorator="['installationType',{ rules: [{ required: true, message: '请选择安装类别！' }] }]" v-if="course == 1">
          <a-select-option v-for="type in restaurantTypes" :key="type.code">{{ type.label }}</a-select-option>
        </a-select>
        <a-select
          v-else-if="course == 0"
          mode="multiple"
          v-decorator="['installationType',{ rules: [{ required: true, message: '请选择安装类别！' }] }]"

          @change="handleChange"
        >
          <a-select-option v-for="type in restaurantTypes" :key="type.code">{{ type.label }}</a-select-option>
        </a-select>
      </a-form-item>
      <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="金额类型">
        <a-input v-decorator="['priceName',{ rules: [{ required: true, message: '请输入金额类型' }] }]"/>
        <!--<a-select  v-decorator="['priceName',{ rules: [{ required: true, message: '请输入字段类型' }] }]">-->
        <!--<a-select-option  v-for="(val,key) in fieldType" :key="key" :value="key">{{val}}</a-select-option>-->
        <!--</a-select>-->
      </a-form-item>
      <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="成本类型">
        <a-select v-decorator="['costType']" allowClear="true">
          <a-select-option v-for="type in restaurantTypes1" :key="type.code"> {{ type.label }}</a-select-option>
        </a-select>
      </a-form-item>
      <a-form-item label="添加时间" :labelCol="labelCol" :wrapperCol="wrapperCol" v-if="course == 1">
        <a-date-picker
          v-model="bondTime"
          style="width: 100%"
          show-time
          @change="onChange1"
          format="YYYY-MM-DD HH:mm:ss"
          @ok="onOk1" />
      </a-form-item>
      <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="示例图">
        <div class="clearfix">
          <a-upload
            :action="uploadUrlb"
            accept="image/*"
            listType="picture-card"
            :fileList="fileList"
            :headers="headers"
            :beforeUpload="beforeUpload"
            @preview="handPreview"
            @change="handChange"
          >
            <div v-if="fileList.length < 3">
              <a-icon type="plus"/>
              <div class="ant-upload-text">示例图</div>
            </div>
          </a-upload>
          <a-modal :visible="previewVisible" :footer="null" @cancel="handCancel">
            <img alt="example" style="width: 100%" :src="imageUrl"/>
          </a-modal>
        </div>
      </a-form-item>
    </a-form>
    <div style="text-align: center" :class="status ==1 ? 'readyOnly':''">
      <a-button @click="handleSubmit" type="primary" style="margin-right: 8px">保存</a-button>
      <a-button @click="showModal">取消</a-button>
    </div>
  </a-modal>
</template>
<script>
import { getDetails, update, save } from '@/api/basicdatas/AmountManagement'
import { ACCESS_TOKEN } from '@/store/mutation-types'
import pick from 'lodash.pick'
import { getDictMap } from '../../../utils/dict'

export default {
  name: 'BrandModal',
  props: {
  },
  components: {
  },
  data () {
    return {
      queryParam: {},
      visible: false,
      restaurantOperTypeMap: {},
      restaurantTypes: [],
      restaurantOperTypeMap1: {},
      restaurantTypes1: [],
      labelCol: {
        xs: { span: 24 },
        sm: { span: 5 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 }
      },
      confirmLoading: false,
      mdl: {},
      form: this.$form.createForm(this),
      data: [],
      course: 0,
      // 上传
      uploadUrlb: process.env.VUE_APP_API_BASE_URL + '/dfs/upload?type=basicdatas',
      headers: {
        token: Vue.ls.get(ACCESS_TOKEN)
      },
      fileList: [],
      previewVisible: false,
      imageUrl: '',
      isType: 0,
      bondTime: null,
      bondTimeTrue: null,
      status: 0
    }
  },
  beforeCreate () {
  },
  async created () {
    this.restaurantTypes = []
    this.restaurantTypes1 = []
    this.restaurantOperTypeMap = await getDictMap('install_type')
    this.restaurantOperTypeMap1 = await getDictMap('cost_type')
    this.restaurantOperTypeMap.forEach((value, key) => {
      // console.log(value,key)
      this.restaurantTypes.push({ code: key, label: value })
    })
    this.restaurantOperTypeMap1.forEach((value, key) => {
      // console.log(value,key)
      this.restaurantTypes1.push({ code: key, label: value })
    })
  },
  mounted () {
  },
  methods: {
    onChange1 (date, dateString) {
      // console.log('Formatted Selected Time: ',date, dateString);
      this.bondTime = date
      this.bondTimeTrue = dateString
    },
    beforeUpload (file) {
      const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png'
      if (!isJpgOrPng) {
        this.$message.error('上传文件格式不支持!')
        this.isType = 1
        return false
      } else {
        this.isType = 0
      }
    },
    handChange ({ fileList }) {
      console.log(fileList)
      if (this.isType == 0) {
        this.fileList = fileList
        this.imageUrl = fileList[0].response.url
        console.log(this.imageUrl)
      }
    },
    handPreview (file) {
      console.log(file)
      if (file.response) {
        this.imageUrl = process.env.VUE_APP_API_BASE_URL + '/dfs/download?fileName=' + file.response.url + '&token=' + Vue.ls.get(ACCESS_TOKEN)
      } else {
        this.imageUrl = process.env.VUE_APP_API_BASE_URL + '/dfs/download?fileName=' + file.url + '&token=' + Vue.ls.get(ACCESS_TOKEN)
      }
      this.previewVisible = true
    },
    handCancel () {
      this.previewVisible = false
    },

    handleChange (value) {
      // console.log(`selected ${value}`);
    },
    showModal () {
      this.visible = !this.visible
    },
    add () {
      this.fileList = []
      this.imageUrl = ''
      this.form.resetFields()
      this.course = 0
      this.visible = true
    },
    edit (record, status) {
      this.course = 1
      this.status = status
      this.bondTime = null
      const _this = this
      getDetails(record.id).then(res => {
        this.mdl = Object.assign(res)
        this.imageUrl = res.priceUrl
        _this.visible = true
        if (this.mdl.createTime != null) {
          this.bondTime = moment(this.mdl.createTime)
        } else {
          this.bondTime = null
        }
        this.$nextTick(() => {
          this.form.setFieldsValue(pick(this.mdl, 'id', 'installationType', 'priceName', 'costType'))
          if (res.priceUrl != null) {
            this.getImgToBase64(process.env.VUE_APP_API_BASE_URL + '/dfs/download?fileName=' + res.priceUrl + '&token=' + Vue.ls.get(ACCESS_TOKEN), function (data) {
              _this.fileList = [{
                uid: '',
                name: '',
                thumbUrl: data,
                url: res.priceUrl
              }]
            })
          } else {
            this.fileList = []
          }
        })
      })
    },
    handleSubmit (e) {
      e.preventDefault()
      this.form.validateFields((err, values) => {
        if (!err) {
          // console.log('Received values of form: ', values)
          this.confirmLoading = true
          if (this.course == 0) {
            values.installationType = values.installationType.join(',')
          }
          if (this.course == 0) {
            values.priceUrl = this.imageUrl
            save(values).then(res => {
              if (res.code === 0) {
                if (res.data != '金额类型名称重复') {
                  this.$message.success(res.data)
                  this.$emit('ok', 1)
                  this.visible = false
                } else {
                  this.$message.error(res.data)
                }
              }
            }).catch(() => {
              this.$message.error('系统错误，请稍后再试')
            }).finally(() => {
              this.confirmLoading = false
            })
          } else if (this.course == 1) {
            values.priceUrl = this.imageUrl
            values.createTime = this.bondTimeTrue
            update(values).then(res => {
              // console.log(values)
              if (res.code === 0) {
                this.$message.success(res.data)
                this.$emit('ok', 2)
                this.visible = false
              }
            }).catch(() => {
              this.$message.error('系统错误，请稍后再试')
            }).finally(() => {
              this.confirmLoading = false
            })
          }
        }
      })
    },
    // 将图片转换为Base64
    getImgToBase64 (url, callback) {
      var canvas = document.createElement('canvas')
      var ctx = canvas.getContext('2d')
      var img = new Image()
      img.crossOrigin = 'Anonymous'
      img.onload = function () {
        canvas.height = img.height
        canvas.width = img.width
        ctx.drawImage(img, 0, 0)
        var dataURL = canvas.toDataURL('image/png')
        callback(dataURL)
        canvas = null
      }
      img.src = url
    }
  },
  watch: {
    /*
        'selectedRows': function (selectedRows) {
          this.needTotalList = this.needTotalList.map(item => {
            return {
              ...item,
              total: selectedRows.reduce( (sum, val) => {
                return sum + val[item.dataIndex]
              }, 0)
            }
          })
        }
        */
  }
}
</script>
<style scoped>
  .readyOnly{
    pointer-events: none;
  }
</style>
